import SignUpHeader from '../SignUpPage/SignUpHeader.js';
import { VectorIcon } from '../SignUpPage/VectorIcon.tsx';
import { VectorIcon1 } from '../SignUpPage/VectorIcon1.tsx';
import VerifyCodeForm from './VerifyCodeForm.js';

function VerifyCode() {
  return (
    <div className="w-full min-h-screen bg-gray-100">
      {/* Header */}
      <div className="fixed top-0 left-0 w-full h-[103px] bg-white border border-gray-200 shadow-sm z-10">
        <div className="w-full h-full">
          <SignUpHeader />
        </div>
      </div>

      {/* Main content area */}
      <div className="flex flex-col lg:flex-row min-h-screen pt-32 lg:pt-40">
        {/* Left vector icons - hidden on small screens */}
        <div className="hidden lg:block lg:w-1/6 relative">
          {/* Left vector */}
          <div className="fixed left-0 top-[10%] w-[278px] h-[324px] -translate-x-20 lg:-translate-x-24">
            <VectorIcon1 className="w-full h-full" />
          </div>
        </div>

        {/* Main form content */}
        <div className="flex-1 lg:w-2/3 px-4 sm:px-6 lg:px-8">
          <div className="max-w-2xl mx-auto mt-8 lg:mt-16">
            {/* Form container */}
            <div className="bg-white rounded-lg shadow-md border border-gray-200 p-6 sm:p-8">
              <VerifyCodeForm />
            </div>
          </div>
        </div>

        {/* Right vector icon - hidden on small screens */}
        <div className="hidden lg:block lg:w-1/6 relative">
          {/* Right vector */}
          <div className="fixed right-0 bottom-0 w-[395.9px] h-[315.78px] translate-x-20 lg:translate-x-24">
            <VectorIcon className="w-full h-full" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyCode;